import { Link } from "react-router-dom";
import { Reveal } from "@/components/shared/Reveal";
import { ArrowRight } from "lucide-react";
import { openSignIn } from "@/lib/signInModal";
import { openPreRegister } from "@/lib/preRegisterModal";

export const BrokerCTA = () => (
  <section data-testid="broker-bottom-cta-section" className="py-20 md:py-28 bg-rr-navy relative overflow-hidden">
    <div className="grain-overlay" />
    <div className="max-w-3xl mx-auto px-5 md:px-8 text-center relative">
      <Reveal>
        <h2 data-testid="broker-bottom-cta-heading" className="font-heading text-3xl md:text-5xl font-extrabold text-white leading-tight tracking-tight">
          Brokers: Start Building Your Driver Network.
        </h2>
        <p className="text-white/60 mt-5 max-w-xl mx-auto leading-relaxed">
          Build your network. Organize your preferred drivers. Send opportunities. Track assignments. Simplify documentation and billing.
        </p>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
          <button onClick={() => openSignIn("register", "broker")} data-testid="broker-bottom-cta-join-button" className="inline-flex items-center gap-2 bg-rr-orange text-white font-bold px-8 py-4 rounded-full hover:bg-white hover:text-rr-navy transition-all hover:-translate-y-1">
            Join RelayRigs as a Broker <ArrowRight size={18} />
          </button>
          <button onClick={() => openPreRegister("broker")} data-testid="broker-bottom-cta-preregister-button" className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-white font-bold px-8 py-4 rounded-full hover:bg-white/20 transition-all">
            Pre-Register Your Brokerage
          </button>
        </div>
        <Link to="/broker-portal" data-testid="broker-bottom-cta-portal-link" className="inline-block mt-6 text-sm font-bold text-white/60 hover:text-white transition-colors">
          Already a broker? Go to the Broker Portal →
        </Link>
      </Reveal>
    </div>
  </section>
);
